export interface TF1QRPayload {
    phone: string;
    message: string;
}

export enum AppState {
    OPENED = 'OPENED',
    CLOSED = 'CLOSED',
}

export interface TF1AppState {
    payload: TF1QRPayload;
    appState: AppState;
    domain: string;
}